var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H24V24H0z",
    transform: "translate(-336 -559) translate(48 279) translate(0 280) translate(288)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#191C24",
    d: "M22.867 11.776C20.796 7.734 16.695 5 12 5 7.305 5 3.203 7.736 1.133 11.776c-.177.35-.177.764 0 1.115C3.204 16.932 7.305 19.667 12 19.667c4.695 0 8.797-2.737 10.867-6.776.177-.35.177-.765 0-1.115zM12 17.833c-3.038 0-5.5-2.462-5.5-5.5 0-3.037 2.462-5.5 5.5-5.5s5.5 2.463 5.5 5.5c.001 3.036-2.459 5.499-5.495 5.5H12zm0-9.166c-.327.004-.652.053-.967.144.599.813.424 1.957-.389 2.556-.644.474-1.522.474-2.166 0-.53 1.95.622 3.96 2.572 4.488 1.95.53 3.96-.622 4.49-2.572.528-1.95-.623-3.96-2.573-4.489-.315-.085-.64-.128-.967-.127z",
    transform: "translate(-336 -559) translate(48 279) translate(0 280) translate(288)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEye);
export default __webpack_public_path__ + "static/media/icon-eye.84aa8433.svg";
export { ForwardRef as ReactComponent };